import CebeoService from '@/services/cebeoService/CebeoService';

class AuthService {
  getStores() {
    return CebeoService.doApiCall('get', `${process.env.VUE_APP_API}/stores/showrooms`, 'get stores');
  }

  getRegions() {
    return CebeoService.doApiCall('get', `${process.env.VUE_APP_API}/regions`, 'get regions');
  }

  getDayparts(data) {
    return CebeoService.doApiCall('get', `${process.env.VUE_APP_API}/stores/${data.storeId}/dayparts`, 'get dayparts', { params: data });
  }

  getAmbiences() {
    return CebeoService.doApiCall('get', `${process.env.VUE_APP_API}/ambiences`, 'getAmbiences');
  }

  createVisit(data) {
    return CebeoService.doApiCall('post', `${process.env.VUE_APP_API}/visits`, 'createVisit', data);
  }

  uploadFloorplan(visitId, file) {
    return CebeoService.doApiCall(
      'post',
      `${process.env.VUE_APP_API}/visits/${visitId}/floorplan`,
      {},
      file
    );
  }
}

export default new AuthService();
